// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ph-0";
export var animationContainer = "_ph-1";
export var itemPrice = "_ph-a";
export var itemizedContent = "_ph-9";
export var itemizedHeader = "_ph-7";
export var itemizedRow = "_ph-8";
export var itemizedSection = "_ph-6";
export var modalContent = "_ph-2";
export var orderName = "_ph-3";
export var refundOption = "_ph-4";
export var refundOptionsContainer = "_ph-5";
export var shippingLabel = "_ph-b";
export var totalRow = "_ph-c";